import { styled, css, useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { a as _objectSpread2, b as _extends } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Li, Span, A, Div } from '@vebox/etui-system-elements';
import Icon from './Icon/Icon.js';
import { darken } from '@vebox/etui-colors';

const DropdownMenuLi = styled(Li)`
  list-style: none;
`;

const DropdownItemText = styled(Span)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: ${props => props.useTextRtlDirection ? 'rtl' : 'ltr'};
  text-align: left;
`;

const MenuItemA = styled(A)`
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  min-height: 42px;
  text-decoration: none;

  ${({
  theme
}) => css`
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeBase};
    font-weight: ${theme.typography.fontWeightRegular};
    line-height: ${theme.typography.lineHeightBase};
    letter-spacing: ${theme.typography.button.letterSpacing};
    color: ${theme.palette.common.white};
    padding-left: ${theme.spacing.md}px;
  `};

  &:hover {
    background-color: ${({
  theme
}) => darken(theme.palette.black[80], 0.3)};
  }

  ${props => {
  if (props.addSpaceLeft) {
    return css`
        padding-left: ${props.theme.spacing.xlg}px;
      `;
  }
  return ``;
}};

  ${props => props.isActive && css`
      background-color: ${darken(props.theme.palette.black[80], 0.3)};
    `};

  ${props => props.isSelected && css`
      background-color: ${darken(props.theme.palette.black[80], 0.3)};
    `};
`;

const ContextMenuItem = props => {
  const theme = useTheme();
  const handleOnClick = event => {
    event.preventDefault();
    if (typeof props.onClick === 'function') {
      props.onClick(event);
    }
  };
  const menuLinkProps = _objectSpread2(_objectSpread2({}, props), {}, {
    onClick: event => handleOnClick(event)
  });
  return /*#__PURE__*/createElement(DropdownMenuLi, props, /*#__PURE__*/createElement(MenuItemA, _extends({
    addSpaceLeft: props.addSpaceLeft,
    isActive: props.isActive,
    isSelected: props.isSelected
  }, menuLinkProps), props.icon ? /*#__PURE__*/createElement(Div, {
    lineHeight: 0,
    mr: theme.spacing.sm
  }, /*#__PURE__*/createElement(Icon, props.icon)) : null, /*#__PURE__*/createElement(DropdownItemText, {
    useTextRtlDirection: props.useTextRtlDirection
  }, props.children)));
};

export { ContextMenuItem as C, DropdownItemText as D };
